// @mui
import type { BoxProps } from '@mui/material';

import { Box } from '@mui/material';

// components
import { useSettingsContext } from '../../components/settings';
// config
import { HEADER, NAV } from '../../config-global';
// hooks
import useResponsive from '../../hooks/useResponsive';

// ----------------------------------------------------------------------

const SPACING = 8;

const Main = ({ children, sx, ...other }: BoxProps) => {
  const { themeLayout } = useSettingsContext();

  const isNavHorizontal = themeLayout === 'horizontal';

  const isNavMini = themeLayout === 'mini';

  const isDesktop = useResponsive('up', 'lg');

  if (isNavHorizontal) {
    return (
      <Box
        component="main"
        sx={{
          pb: `${HEADER.H_MOBILE + SPACING}px`,
          pt: `${HEADER.H_MOBILE + SPACING}px`,
          ...(isDesktop && {
            pb: `${HEADER.H_DASHBOARD_DESKTOP + SPACING}px`,
            pt: `${HEADER.H_DASHBOARD_DESKTOP + 80}px`,
            px: 2,
          }),
        }}
      >
        {children}
      </Box>
    );
  }

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        py: `${HEADER.H_MOBILE + SPACING}px`,
        ...(isDesktop && {
          px: 2,
          py: `${HEADER.H_DASHBOARD_DESKTOP + SPACING}px`,
          width: `calc(100% - ${NAV.W_DASHBOARD}px)`,
          ...(isNavMini && {
            width: `calc(100% - ${NAV.W_DASHBOARD_MINI}px)`,
          }),
        }),
        ...sx,
      }}
      {...other}
    >
      {children}
    </Box>
  );
};

export default Main;
